var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-hide-page article-create" },
    [
      _c("h3", { staticClass: "page-title page-title-bb" }, [
        _c(
          "h4",
          { staticClass: "breadcrumb-c" },
          [
            _c(
              "router-link",
              {
                staticClass: "back-btn",
                attrs: {
                  to: {
                    name: "material",
                    query: {
                      type: 1
                    }
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-angle-left" }),
                _vm._v(" 素材库\n      ")
              ]
            ),
            _vm._v("\n      / 新建图文链接\n    ")
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "form",
        { staticClass: "form-horizontal form", attrs: { role: "form" } },
        [
          _c("div", { staticClass: "hbox tab-pane" }, [
            _c("section", [
              _c(
                "div",
                { staticClass: "form-body article-main-info m-article" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "form-group main-item",
                      staticStyle: { "margin-bottom": "10px" }
                    },
                    [
                      _c("div", { staticClass: "col-sm-12" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.title,
                              expression: "title"
                            }
                          ],
                          staticClass: "form-control article-title",
                          attrs: { placeholder: "请输入标题" },
                          domProps: { value: _vm.title },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.title = $event.target.value
                            }
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group main-item" }, [
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.author,
                            expression: "author"
                          }
                        ],
                        staticClass: "form-control article-author",
                        attrs: { placeholder: "请输入作者" },
                        domProps: { value: _vm.author },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.author = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group main-item" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-12 editor-metro",
                        staticStyle: { position: "relative" }
                      },
                      [
                        _c("c-editor", {
                          attrs: { config: _vm.editor },
                          on: {
                            "update:config": function($event) {
                              _vm.editor = $event
                            },
                            "editor-content-chg": _vm.editorContentChg
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-group main-item",
                  staticStyle: { display: "none" },
                  attrs: { id: "codeview" }
                },
                [
                  _c("div", { staticClass: "col-sm-12" }, [
                    _c("pre", [_vm._v(_vm._s(_vm.editor.content))])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-body article-ext-info" }, [
                _c("div", { staticClass: "form-group" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-8" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("c-file-upload", {
                        attrs: { config: _vm.cover },
                        on: {
                          "update:config": function($event) {
                            _vm.cover = $event
                          }
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "col-sm-2 control-label" }, [
                    _vm._v("摘要")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-7" }, [
                    _c(
                      "p",
                      { staticClass: "form-control-static form-limit-tip" },
                      [
                        _vm._v(
                          "\n                选填，如果不填写会默认抓取正文前54个字\n              "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.digest,
                          expression: "digest"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { height: "120px" },
                      attrs: { rows: "3" },
                      domProps: { value: _vm.digest },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.digest = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(2)
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-actions", staticStyle: { "z-index": "1000" } },
            [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "hbox tab-pane" }, [
                  _c("section", { staticStyle: { "border-right": "0" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-body",
                        staticStyle: {
                          "padding-top": "0",
                          "padding-bottom": "0"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "form-group",
                            staticStyle: { "margin-bottom": "0" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-sm-offset-2 col-sm-8" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn m-white",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.preview()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    预览\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn m-green",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.submit()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    保存\n                  "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("aside", { staticClass: "article-aside" })
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("c-modal2", { attrs: { config: _vm.previewConf } }, [
        _c("div", { staticClass: "article m-article preview" }, [
          _c("div", { staticClass: "article-inner" }, [
            _c("h2", { staticClass: "article-title" }, [
              _vm._v(_vm._s(_vm.title))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "article-meta" }, [
              _c("a", { staticClass: "article-meta" }, [
                _vm._v(_vm._s(_vm.author))
              ])
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "article-content",
              domProps: { innerHTML: _vm._s(_vm.editor.content) }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "video-player-wrap" }, [
          _c("div", { staticClass: "mask" }),
          _vm._v(" "),
          _c("div", { staticClass: "v-player" }, [
            _c(
              "video",
              {
                staticClass: "video-js vjs-default-skin vjs-big-play-centered",
                attrs: { id: "video-player", controls: "", preload: "auto" }
              },
              [
                _c("p", { staticClass: "vjs-no-js" }, [
                  _vm._v(
                    "\n            To view this video please enable JavaScript, and consider\n            upgrading to a web browser that\n            "
                  ),
                  _c("a", { attrs: { href: "#", target: "_blank" } }, [
                    _vm._v("supports HTML5 video")
                  ])
                ])
              ]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "control-label col-sm-2" }, [
      _vm._v("封面\n              "),
      _c("span", { staticClass: "required" }, [_vm._v(" * ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", { staticClass: "form-control-static form-limit-tip" }, [
        _vm._v("\n                  大图建议尺寸：900*560\n                ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("aside", { staticClass: "article-aside" }, [
      _c("h3", [_vm._v("多媒体")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }